import { PageHeader, Space } from 'antd';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRequestsContext } from '../../components/Requests/context/requests.ctx';
import { Filters, TableRequests } from '../../components/Requests/components';
import { requestersSocket } from '../../sockets/modules/requests-socket.module';
import { useWorkspaceStore } from '../../store/workspace.store';

const RequestsScreen: FC = () => {
    const { t } = useTranslation('small-fleet-orders');

    const workspace = useWorkspaceStore((state) => state.data);

    const {
        pagination,
        searchParams,
        handleSearchParam,
        fetchData,
    } = useRequestsContext();

    useEffect(() => {
        fetchData();
    }, [searchParams, pagination.page]);

    useEffect(() => {
        requestersSocket.send(workspace?.keyName || '');
    }, [workspace?.keyName]);

    return (
        <div className="screen">
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <PageHeader
                    title={t('HEADER')}
                    style={{ padding: 0 }}
                />
                <Filters
                    loading={false}
                    refreshData={fetchData}
                    handleSearchParam={handleSearchParam}
                />
                <TableRequests />
            </Space>
        </div>
    );
};

export { RequestsScreen };
